/**
 * 用户授权实体
 */

import { useState, useEffect } from 'react';
import {
    Modal,
    Row,
    Col,
    message,
    Select,
    Input,
} from 'antd';
import $ from 'jquery';
import { AddRequestHeaders, rff } from '../../incs/FunHelper';

import CNF from '../../incs/Config';

const { Option } = Select;
const { TextArea } = Input;

const Entity = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);
    const [groupsLists, setGroupsLists] = useState([]);
    const [viewULID, setViewULID] = useState(null);
    const [description, setDescription] = useState('');

    const cancel = () => {
        props.setOpen(false);
        setLoading(false);
        setViewULID(null);
        setDescription('');
    };

    useEffect(() => {
        if (props.open && groupsLists.length < 1) {
            /**
             * 获取用户下拉列表
             */
            $.ajax({
                url: `${CNF.api}groups?rss=list&rolename=seal`,
                headers: AddRequestHeaders(),
                type: 'GET',
                dataType: 'JSON', success: function (data) {
                    if (data.res === 0) {
                        setGroupsLists(data.dat);
                    }
                }
            })
        }
    }, [props.open, groupsLists.length]);

    const ok = () => {
        if (viewULID === null) {
            messageApi.error('可视者不能为空！');
            return;
        }
        if (description === '') {
            messageApi.error('备注不能为空！');
            return;
        }

        setLoading(true);
        $.ajax({
            url: `${CNF.api}users/${props.record.key}`,
            headers: AddRequestHeaders(),
            type: 'PATCH',
            dataType: 'JSON',
            data: JSON.stringify({
                'action': CNF.actionName.ACCREDIT,
                'view_ulid': viewULID,
                'description': description,
            }), success: function (data) {
                if (data.res === 0) {
                    messageApi.success(data.msg, CNF.messageDuration);
                    setTimeout(function () {
                        cancel();
                        props.isRefresh();
                    }, CNF.messageDuration * 1000);
                } else {
                    messageApi.error(data.msg, CNF.messageDuration);
                }
            }
        }).fail(function (data) {
            messageApi.error(data.responseJSON.detail, CNF.messageDuration);
        });
    };


    return (
        <>
            {contextHolder}
            <Modal
                width={400}
                title={'用户授权: ' + (props.record ? props.record.username : '')}
                open={props.open}
                onOk={ok}
                onCancel={cancel}
                keyboard={true}
                okText='确认'
                cancelText='取消'
                okButtonProps={{ disabled: loading }}
            >
                <Row>
                    <Col span={24}>{rff}可视者</Col>
                    <Col span={24}>
                        <Select
                            showSearch
                            placeholder='可视者'
                            style={{ width: '100%' }}
                            onChange={(value) => setViewULID(value ? value : '')}
                            filterOption={(input, option) =>
                                option.props.children.indexOf(input) >= 0
                            }
                        >
                            <Option value=''>可视者</Option>
                            {
                                groupsLists.length > 0 && groupsLists.map((item, index) => {
                                    return <Option key={index} value={item['key']}>{item['groupname']}</Option>
                                })
                            }
                        </Select>
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop }}>
                    <Col span={24}>{rff}备注</Col>
                    <Col span={24}>
                        <TextArea
                            placeholder='备注可写在这里...'
                            autoSize={{ minRows: 3, maxRows: 5 }}
                            onChange={(e) => setDescription(e.target.value)}
                            value={description}
                        />
                    </Col>
                </Row>
            </Modal>
        </>
    );
}

export default Entity